import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { HOME, PRESCRIPTION } from '@pages/Payment/PaymentComplete/focuskey';
import { generateHistoryDetailPath, ROOT, generatePrescriptionPath } from '@router/path';
import constate from 'constate';
import { useNavigate, useParams } from 'react-router';

const usePaymentComplete = () => {
  const { treatmentId = '', isPrescriptionExists } = useParams();
  const navigate = useNavigate();

  const { setFocus } = useFocusable();
  const setButtonFocus = () => {
    if (isPrescriptionExists === 'true') setFocus(PRESCRIPTION);
    else setFocus(HOME);
  };

  const goTreatmentHistoryDetail = () =>
    navigate(generateHistoryDetailPath(treatmentId), { replace: true });
  const goPrescription = () =>
    navigate(generatePrescriptionPath(treatmentId), { replace: true });
  const goHome = () => navigate(ROOT);

  return {
    isPrescriptionExists,
    setButtonFocus,
    goTreatmentHistoryDetail,
    goPrescription,
    goHome
  };
};

export const [PaymentCompleteProvider, userPaymentCompleteContext] =
  constate(usePaymentComplete);
